import { Outlet } from 'react-router-dom';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';
import { withProfiler } from '@sentry/react';

export const SimulationsDashboardView = () => {
  useSentrySetDashBoardTag({ dashboardName: 'Simulations' });

  return <Outlet />;
};

export const SimulationsDashboard = withProfiler(SimulationsDashboardView);
